import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/es6.object.keys";
import _defineProperty from "/var/lib/jenkins/workspace/yesep-ui/node_modules/@babel/runtime-corejs2/helpers/esm/defineProperty.js";
import _toConsumableArray from "/var/lib/jenkins/workspace/yesep-ui/node_modules/@babel/runtime-corejs2/helpers/esm/toConsumableArray.js";
import "core-js/modules/es6.function.name";
import "core-js/modules/web.dom.iterable";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { ModalFormMixin } from '@/mixins/ModalFormMixin';
import pick from 'lodash.pick';
import { getAction, httpAction } from '@api/manage';
import { queryUserTreeList } from '@/api/api';
import moment from 'moment';
import IwsUpload from '@comp/upload/IwsUpload';
import { GetSiteIdMixin } from '@/mixins/GetSiteIdMixin';
import SelectAssetChemicalModal from '@views/assets/SelectAssetChemicalModal1';
import SelectAssetModal from '@views/assets/SelectAssetModal';
var columnsItem = [{
  title: '仪表名称',
  dataIndex: 'instrumentId',
  fixed: 'left',
  align: 'center',
  width: '200px',
  scopedSlots: {
    customRender: 'instrumentId'
  }
}, {
  title: '标物名称',
  dataIndex: 'chemicalId',
  fixed: 'left',
  align: 'center',
  width: '200px',
  scopedSlots: {
    customRender: 'chemicalId'
  }
}, {
  title: '标样浓度',
  dataIndex: 'concentration',
  fixed: 'left',
  align: 'center',
  width: '200px',
  scopedSlots: {
    customRender: 'concentration'
  }
}, {
  title: '使用数量',
  dataIndex: 'usageAmount',
  fixed: 'left',
  align: 'center',
  width: '200px',
  scopedSlots: {
    customRender: 'usageAmount'
  }
}, {
  title: '配置时间',
  dataIndex: 'configureTime',
  align: 'center',
  // width: '10%',
  scopedSlots: {
    customRender: 'configureTime'
  }
}, {
  title: '有效期至',
  dataIndex: 'termOfValidity',
  align: 'center',
  // width: '7%',
  scopedSlots: {
    customRender: 'termOfValidity'
  }
}, {
  title: '更换原因',
  dataIndex: 'reason',
  align: 'center',
  // width: '7%',
  scopedSlots: {
    customRender: 'reason'
  }
}, {
  title: '备注',
  dataIndex: 'remark',
  align: 'center',
  // width: '14%',
  scopedSlots: {
    customRender: 'remark'
  }
}, {
  title: '附件',
  align: 'center',
  width: '80px',
  dataIndex: 'operation',
  scopedSlots: {
    customRender: 'operation'
  }
}];
var dataItem = [];
var addItemDataIndex = 0;
export default {
  name: 'ReagentReplacementModal',
  mixins: [ModalFormMixin, GetSiteIdMixin],
  components: {
    IwsUpload: IwsUpload,
    SelectAssetChemicalModal: SelectAssetChemicalModal,
    SelectAssetModal: SelectAssetModal
  },
  data: function data() {
    return {
      title: '标样更换表单',
      tableName: 'om_reagent_replacement',
      form_fields: ['siteId', 'userId', 'remark', 'tenantId'],
      form_fields_time: ['replaceDate'],
      codeDict: 'instrumentId,chemicalId',
      userTree: [],
      equipmentOptions: [],
      dataItem: dataItem,
      columnsItem: columnsItem,
      addItemDataIndex: addItemDataIndex,
      validatorRules: {
        userId: {
          rules: [{
            required: true,
            message: '请输入运维人员!'
          }]
        },
        replaceDate: {
          rules: [{
            required: true,
            message: '请输入更换时间!'
          }]
        }
      },
      url: {
        querySiteDevice: '/om/chemical/replace/querySiteDevice/',
        queryProductAssets: '/om/chemical/replace/queryProductAssets/',
        queryChemicalReplaceItem: '/om/chemical/replace/item/',
        queryReplacemenItem: '/om/reagent/replacement/item/',
        deleteReplacemenItem: '/om/reagent/replacement/item/'
      },
      columns: [{
        title: '名称',
        dataIndex: 'title',
        width: '300px',
        align: 'center'
      }, {
        title: '值',
        dataIndex: 'value',
        align: 'center',
        width: '300px',
        scopedSlots: {
          customRender: 'value'
        }
      }, {
        title: '附件',
        dataIndex: 'action',
        align: 'center',
        scopedSlots: {
          customRender: 'action'
        }
      }],
      selectedAssetChemical: [],
      tabsKey: '1',
      tableKey1: '1',
      tablePageIndex: 1,
      dataSource: {},
      tableData: [],
      deviceId: ''
    };
  },
  props: ['pagePath'],
  watch: {
    currentSiteId: function currentSiteId(value) {
      this.siteId = value;
    },
    currentSiteName: function currentSiteName(newVal) {
      this.siteName = newVal;
    }
  },
  created: function created() {},
  methods: {
    moment: moment,
    selectAssetChemical: function selectAssetChemical(index1) {
      this.tableKey = index1;
      this.$refs.AssetChemicalModal.category = 23;
      this.$refs.AssetChemicalModal.disableSubmit = true;
      this.$refs.AssetChemicalModal.add(this.selectedAssetChemical, this.assetChemicalIds, this.deviceId);
    },
    // 子modal回调
    choseAssetChemical: function choseAssetChemical(productList) {
      var _this = this;

      console.log(productList[0]);
      this.dataItem.forEach(function (e, index) {
        if (index === _this.tableKey) {
          e.chemicalId = productList[0].id;
          e.chemicalName = productList[0].name + '(' + productList[0].unit_dictText + ')';
          e.concentration = productList[0].intensity;
          e.concentrationUnit = productList[0].intensityUnit;
        }
      });
      this.$forceUpdate();
      console.log(this.dataItem);
    },
    // 仪器名称
    selectAssets: function selectAssets(record, index, index1) {
      this.tableKey1 = index1;
      this.selectedRecord = record;
      this.$refs.AssetListModal.siteId = this.siteId;
      this.$refs.AssetListModal.disableSubmit = true;
      this.$refs.AssetListModal.add(record.productName, record.equipmentId);
    },
    choseProduct: function choseProduct(productList) {
      var _this2 = this;

      this.deviceId = '';
      this.dataItem.forEach(function (e, index) {
        if (index === _this2.tableKey1) {
          e.instrumentId = productList[0].id;
          e.instrumentName = productList[0].productName;
          _this2.deviceId = productList[0].productId;
        }
      });
      console.log('this.dataItem', this.dataItem);
      this.$forceUpdate();
    },
    addTable: function addTable() {
      var _this3 = this;

      var newData = _toConsumableArray(this.dataItem);

      newData.push({
        instrumentId: '',
        chemicalId: '',
        certificateNo: '',
        usageAmount: '',
        concentration: '',
        concentrationUnit: '',
        reason: '',
        configureTime: '',
        termOfValidity: '',
        remark: '',
        editable: true
      });
      this.dataItem = newData;
      var dataObj = {
        instrumentId: '',
        usageAmount: '',
        chemicalId: '',
        certificateNo: '',
        concentration: '',
        concentrationUnit: '',
        reason: '',
        configureTime: '',
        termOfValidity: '',
        remark: '',
        editable: true
      };
      var arr = [];
      this.columnsItem.forEach(function (item, index) {
        if (index < _this3.columnsItem.length - 1) {
          var _dataItem = {
            title: item.title,
            code: item.dataIndex,
            value: null
          };

          if (item.dataIndex == 'configureTime') {
            _dataItem.value = moment(new Date(), 'YYYY-MM-DD HH:mm:ss');
          }

          if (item.dataIndex == 'termOfValidity') {
            _dataItem.value = moment(new Date(), 'YYYY-MM-DD HH:mm:ss');
          }

          if (_this3.codeDict.indexOf(_dataItem.code) > -1) {
            _dataItem.fileSrc = "om_reagent_replacement_item_".concat(_dataItem.code);
            _dataItem.srcId = null;
          }

          arr.push(_dataItem);
        }
      });
      this.tableData.push(arr);
      this.tablePageIndex = this.tableData.length;
      console.log('tableData', this.tableData);
    },
    handleDelete: function handleDelete(id) {
      var _this4 = this;

      if (this.tableData.length <= 0) return;

      if (id) {
        this.tableData.splice(this.tablePageIndex - 1, 1);
        this.dataItem.splice(this.tablePageIndex - 1, 1);
        httpAction(this.url.deleteReplacemenItem + '?id=' + id, '', 'DELETE').then(function (res) {
          if (res.success) {
            _this4.$notification.success({
              message: res.message
            });
          } else {
            _this4.$notification.warning({
              message: res.message
            });
          }
        });
      } else {
        this.tableData.splice(this.tablePageIndex - 1, 1);
        this.dataItem.splice(this.tablePageIndex - 1, 1);
      }

      if (this.tableData.length > 1 && this.tablePageIndex > 1) {
        this.tablePageIndex--;
      } else {
        this.tablePageIndex = 1;
      }
    },
    changeUpload: function changeUpload(e, record) {
      e.sysFileList.forEach(function (item) {
        item.fileSrc = record.fileSrc;
      });
      e.fileDelList.forEach(function (item) {
        item.fileSrc = record.fileSrc;
      });
      console.log('e,record', e, record);
      record.sysFileList = e.sysFileList;
      record.fileDelList = e.fileDelList;
      console.log('this', this.tableData);
    },
    getConcentrationUnit: function getConcentrationUnit(index, e) {
      this.dataItem[index].concentrationUnit = e;
    },
    getUsageAmountUnit: function getUsageAmountUnit(index, e) {
      this.dataItem[index].usageAmountUnit = e;
    },
    getData: function getData(value, e) {
      value['value'] = e;
    },
    add: function add(siteId) {
      this.dataItem = [];
      this.tableData = [];
      if (undefined == siteId) this.$message.warning('请选择单个站点');
      this.edit({
        siteId: siteId
      });
    },
    edit: function edit(record) {
      var _this5 = this;

      console.log('record', record);
      this.tabsKey = '1';
      this.form.resetFields();
      this.model = Object.assign({}, record);
      console.log('model:', this.model);
      this.loadTreeList(this.model.siteId);
      this.visible = true; // this.visible1 = false

      this.selectedRowKeys = [];
      this.selectionRows = [];

      if (undefined == this.model.id) {
        this.dataItem = [];
        this.model.userId = this.$store.getters.userInfo.id;
        this.model.replaceDate = moment(new Date(), 'YYYY-MM-DD HH:mm:ss');
        this.model.siteName = this.siteName;
      } else {
        this.getTableItem();
      }

      this.$nextTick(function () {
        var that = _this5;
        that.form.setFieldsValue(pick(that.model, that.form_fields)); //时间格式化

        var timeVal = {};
        that.form_fields_time.forEach(function (item, index) {
          timeVal[item] = that.model[item] ? moment(that.model[item], 'YYYY-MM-DD HH:mm:ss') : null;
        });
        that.form.setFieldsValue(timeVal);
        that.$refs.iwupload.loadUploadFiles();
      });
    },
    getTableItem: function getTableItem() {
      var _this6 = this;

      if (this.model.id != null) {
        getAction(this.url.queryReplacemenItem + this.model.id).then(function (res) {
          if (res.success) {
            var _ReplacemenItem = [];
            _ReplacemenItem = res.result;

            _this6.getSiteDevice(_ReplacemenItem);
          } else {
            _this6.getSiteDevice(ReplacemenItem);
          }
        });
      } else {
        this.getSiteDevice(ReplacemenItem);
      }
    },
    getSiteDevice: function getSiteDevice(ReplacemenItem) {
      var _this7 = this;

      var arr = [];
      var arr3 = [];
      ReplacemenItem.forEach(function (item) {
        var _data;

        var data = (_data = {
          instrumentId: item.instrumentId,
          chemicalId: item.chemicalId,
          certificateNo: item.certificateNo,
          concentration: item.concentration,
          reason: item.reason,
          configureTime: item.configureTime,
          termOfValidity: item.termOfValidity,
          usageAmount: item.usageAmount,
          remark: item.remark,
          id: item.id
        }, _defineProperty(_data, "concentration", item.concentration), _defineProperty(_data, "concentrationUnit", item.concentrationUnit), _defineProperty(_data, "usageAmountUnit", item.usageAmountUnit), _data);
        var arr1 = [];
        var arr2 = [];

        _this7.columnsItem.forEach(function (item1, index) {
          if (index < _this7.columnsItem.length - 1) {
            var tableData = {
              title: item1.title,
              code: item1.dataIndex,
              value: data[item1.dataIndex]
            };

            if (tableData.code == 'termOfValidity') {
              tableData.value = tableData.value ? moment(tableData.value, 'YYYY-MM-DD HH:mm:ss') : null;
            }

            if (tableData.code == 'configureTime') {
              tableData.value = tableData.value ? moment(tableData.value, 'YYYY-MM-DD HH:mm:ss') : null;
            }

            if (_this7.codeDict.indexOf(tableData.code) > -1) {
              tableData.fileSrc = "om_reagent_replacement_item_".concat(tableData.code);
              tableData.srcId = item.id;
            }

            arr1.push(tableData);
            arr2.push(tableData);
            arr2.chemicalName = item.chemicalName;
            arr2.instrumentName = item.instrumentName;
            arr2.instrumentId = item.instrumentId;
            arr2.concentrationUnit = item.concentrationUnit;
            arr2.usageAmountUnit = item.usageAmountUnit;
            arr2.concentration = item.concentration;
            arr2.chemicalId = item.chemicalId;
            arr2.id = item.id;
          }
        });

        arr.push(arr1);
        arr3.push(arr2);
      });
      this.tableData = arr;
      this.dataItem = arr3;
      console.log('this.tableData', this.tableData);
      console.log('this.dataItem', this.dataItem);
    },
    handleOk: function handleOk() {
      var _this8 = this;

      var that = this; // 触发表单验证

      this.form.validateFields(function (err, values) {
        if (!err) {
          that.confirmLoading = true;
          var formData = Object.assign(that.model, values); //时间格式化

          formData.replaceDate = formData.replaceDate ? formData.replaceDate.format('YYYY-MM-DD HH:mm:ss') : null;
          formData = _this8.$refs.iwupload.getUploadListToFromData(formData);
          formData.siteId = _this8.siteId;
          var arr = [];
          console.log('dataItem', _this8.dataItem);
          console.log('arr', _this8.tableData);
          var tableData = [];

          _this8.tableData.forEach(function (item, index) {
            var obj = {};
            var sysFileList = [];
            var fileDelList = [];
            item.forEach(function (item2, index2) {
              obj[item2.code] = item2.value;

              if (item2.code == 'configureTime') {
                obj.configureTime = item2.value ? item2.value.format('YYYY-MM-DD HH:mm:ss') : null;
              }

              if (item2.code == 'termOfValidity') {
                obj.termOfValidity = item2.value ? item2.value.format('YYYY-MM-DD HH:mm:ss') : null;
              }

              if (item2.sysFileList) {
                sysFileList = sysFileList.concat(item2.sysFileList);
                fileDelList = fileDelList.concat(item2.fileDelList);
              }
            });
            obj['chemicalId'] = _this8.dataItem[index].chemicalId;
            obj['instrumentId'] = _this8.dataItem[index].instrumentId;
            obj['concentrationUnit'] = _this8.dataItem[index].concentrationUnit;
            obj['usageAmountUnit'] = _this8.dataItem[index].usageAmountUnit;
            obj['concentration'] = _this8.dataItem[index].concentration;
            obj['id'] = _this8.dataItem[index].id;
            obj.sysFileList = sysFileList;
            obj.fileDelList = fileDelList;
            console.log('obj', obj);
            tableData.push(obj);
          });

          formData.reagentReplacementItemVos = tableData;
          console.log('formData', formData);
          var httpurl = '',
              method = '';

          if (!_this8.model.id) {
            httpurl = _this8.url.add ? _this8.url.add : _this8.pagePath;
            method = 'post';
          } else {
            httpurl = _this8.url.edit ? _this8.url.edit : _this8.pagePath;
            method = 'put';
          }

          httpAction(httpurl, formData, method).then(function (res) {
            if (res.success) {
              _this8.$refs.iwupload.resetUploadFiles();

              that.$notification.success({
                message: res.message
              });
              that.$emit('ok');
              that.close();
            } else {
              that.$notification.warning({
                message: res.message
              });
            }
          }).finally(function () {
            that.confirmLoading = false;
          });
        }
      });
    },
    loadTreeList: function loadTreeList(params) {
      var that = this;
      that.userTree = [];
      that.equipmentOptions = []; // 用户

      queryUserTreeList().then(function (res) {
        if (res.success) {
          for (var i = 0; i < res.result.length; i++) {
            var temp = res.result[i];
            that.userTree.push(temp);
          }
        }
      }); // 站点设备

      getAction(this.url.querySiteDevice + params).then(function (res) {
        if (res.success) {
          that.equipmentOptions = res.result;
        }
      });
    },
    delTable: function delTable(key) {
      var newData = this.dataItem.filter(function (item) {
        return key != item.key;
      });
      this.dataItem = newData;
      this.cacheItemData = newData.map(function (item) {
        return _objectSpread({}, item);
      });
    },
    editTable: function editTable(key) {
      var newData = _toConsumableArray(this.dataItem);

      var target = newData.filter(function (item) {
        return key === item.key;
      })[0];

      if (target) {
        target.editable = true;
        this.dataItem = newData;
      }
    },
    changeUsageAmount: function changeUsageAmount(record, value) {
      if (record) {
        if (value != '') {
          if (value < 0) {
            this.$message.warning('产品数量不能为负数');
          } else {
            record.value = value;
          }
        }
      }

      this.$forceUpdate();
    },
    saveTable: function saveTable(key) {
      var newData = _toConsumableArray(this.dataItem);

      var target = newData.filter(function (item) {
        return key === item.key;
      })[0];

      if (target) {
        delete target.editable;
        this.dataItem = newData;
        this.cacheItemData = newData.map(function (item) {
          return _objectSpread({}, item);
        });
      }
    },
    cancelTable: function cancelTable(key) {
      var newData = _toConsumableArray(this.dataItem);

      var target = newData.filter(function (item) {
        return key === item.key;
      })[0];

      if (target) {
        Object.assign(target, this.cacheItemData.filter(function (item) {
          return key === item.key;
        })[0]);
        delete target.editable;
        this.dataItem = newData;
      }
    },
    filterOption: function filterOption(input, option) {
      return option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0;
    }
  }
};